import {CashBoxType} from "./CashBoxType";

export const CashBoxTypeNames: Record<CashBoxType, string> = {
  [CashBoxType.CASH]: "Efectivo",
  [CashBoxType.CARD]: "Credito",
};
